export default __webpack_public_path__ + "static/media/img-0671-albania-half-face.d41f6462.png";